import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

import { service } from "@/api/api";

Vue.use(VueLocalStorage);

export default {
  state: {
    currentUser: null,
    currentUserId: null || Vue.localStorage.get("userID"),
    accessToken: null || Vue.localStorage.get("accessToken")
  },

  getters: {
    fullName(state) {
      if (state.currentUser)
        return (
          state.currentUser.firstName.split(" ")[0] +
          " " +
          state.currentUser.lastName.split(" ")[0]
        );
      return "Username";
    },
    getImageProfile(state) {
      if (state.currentUser) return state.currentUser.imagefull;
    },
    isAdmin(state){
      if(state.currentUser)
        return state.currentUser.isAdmin
      return false
    },
    roleIn(state){
      if(!state.currentUser) return null;
      return state.currentUser.business.length > 0 ? state.currentUser.business[0].roleIn : undefined;
    },
    canWrite(state){
      if(!state.currentUser) return false;
      return state.currentUser.business.length > 0 ? state.currentUser.business[0].roleIn !== 'guest' : false;
    }
  },

  mutations: {
    ["SET_USER"](state, payload) {
      state.currentUser = payload;
    },

    ["UPDATE_TOKEN"](state, token) {
      service.updateHeaders(token);
      state.accessToken = token;
    }
  },

  actions: {
    async login({ commit }, payload) {
      let { data } = await service.login(payload);
      commit("UPDATE_TOKEN", data.accessToken);
      commit("SET_USER", data.user);
      Vue.localStorage.set("userID", data.user.id);
      commit('SET_BUSINESSID',data.user.business[0].id,{root: true})
      // commit('SET_BUSINESSLIST', data.user.business)
      return data;
    },

    async recoveryPass({},payload) {
      let { data } = await service.recoverPassword(payload);
      return data;
    },

    async getUserByID({ commit }) {
      let { data } = await service.getUserByID(Vue.localStorage.get("userID"));
      commit("SET_USER", data);
        commit("SET_USERBUSINESSLIST", data.business);
      return data
    }
  }
};
